/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable sonarjs/no-duplicate-string */
import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';
import { AppstateFacade } from '@cigna/cigna-for-brokers/shell/data-access';
import {
  Router,
  NavigationStart,
  Event as NavigationEvent,
} from '@angular/router';

import { ShellTrackHandlers } from '@cigna/cigna-for-brokers/shared/analytics-util';
import { getAdobeSiteSection } from '@cigna/cigna-for-brokers/shared/util';
import { AppStateGateway } from '@cigna/cigna-for-brokers/shared/gateways';
import { TranslateService } from '@ngx-translate/core';
import { ContractWithCignaComponent } from '../cigna-contract/contract-with-cigna/contract-with-cigna.component';

@Component({
  selector: 'cigna-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
})
export class ContactUsComponent implements OnInit {
  currentURL: string;
  currentURLSubscription: Subscription;
  constructor(
    private dialogRef: MatDialogRef<ContactUsComponent>,
    private _appstateFacade: AppstateFacade,
    private featureTogglesFacade: FeatureTogglesFacade,
    private router: Router,
    private translate: TranslateService,
    private _gw: AppStateGateway,
    private analytics: ShellTrackHandlers,
    public dialog: MatDialog,
  ) {}
  private _ngUnsubscribe$: Subject<void> = new Subject<void>();
  slideOpen: any = false;
  getAppointedData: any = {};
  isImpersonatorFlag: boolean;
  operatorId: unknown;
  isImpersonatorEnabled: boolean;
  isPreloginNewUiEnabled: boolean;
  isOktaEnabled: boolean;
  isPublicContactUs: boolean;
  did0621ChangesEnabled: boolean;
  isPostLoginContactUsIntuitiveEnabled: boolean;
  profileData$ = this._appstateFacade.isProfileUser$;
  isImpersonatorEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isImpersonatorEnabled',
  ]);
  isPreloginNewUiEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isPreloginNewUiEnabled',
  ]);
  isOktaLoginEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isOktaLoginEnabled',
  ]);
  did0621ChangesEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'did0621ChangesEnabled',
  ]);

  preLoginQuestions = this.translate.instant(`preLoginContactUs.questions`);

  isPostLoginContactUsIntuitiveEnabled$ =
    this.featureTogglesFacade.featuresEnabled([
      'isPostLoginContactUsIntuitiveEnabled',
    ]);
  isOnboardingFlagEnabled: boolean;
  isOnboardingEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isOnboardingEnabled',
  ]);

  ngOnInit(): void {
    this.currentURL = this.router.url;
    if (this.currentURL.includes('public')) {
      this.isPublicContactUs = true;
    }

    this.getAppointedData = this.translate.instant(
      `brokerRegistration.getAppointment`,
    );

    this.currentURLSubscription = this.router.events.subscribe(
      (event: NavigationEvent) => {
        if (event instanceof NavigationStart) {
          this.currentURL = event.url;
        }
      },
    );
    this.did0621ChangesEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isChangesEnabled) => {
        this.did0621ChangesEnabled = isChangesEnabled;
      });

    this.isImpersonatorEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isImpEnabled) => {
        this.isImpersonatorEnabled = isImpEnabled;
      });

    this.isPreloginNewUiEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isNewUi) => {
        this.isPreloginNewUiEnabled = isNewUi;
      });

    this.isOktaLoginEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isFeatureToggleEnabled) => {
        this.isOktaEnabled = isFeatureToggleEnabled;
      });

    this.isPostLoginContactUsIntuitiveEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isFeatureToggleEnabled) => {
        this.isPostLoginContactUsIntuitiveEnabled = isFeatureToggleEnabled;
      });

    this.profileData$.pipe(takeUntil(this._ngUnsubscribe$)).subscribe((res) => {
      if (res) {
        this.operatorId = res.accessTokenBody['agent.operatorId'];
        if (
          this.operatorId &&
          this.operatorId !== '' &&
          this.isImpersonatorEnabled
        ) {
          this.isImpersonatorFlag = true;
        }
      }
    });

    this.isOnboardingEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isEnabled) => {
        this.isOnboardingFlagEnabled = isEnabled;
      });
  }

  close(closeLegalAffirmModal: boolean) {
    this.dialogRef.close({ closeLegalAffirmModal });
  }

  showOnboardingDialog() {
    if (window.innerWidth <= 810) {
      this.router.navigate(['/public/login/cigna-contract']);
    } else {
      this.dialog.open(ContractWithCignaComponent, {
        width: '787px',
        autoFocus: false,
        disableClose: true,
        height: '753px',
        maxHeight: '90vh',
        data: {
          renderMode: 'dialogModal',
        },
      });
    }
  }

  sendEmail(email: string) {
    return `mailto:${email}`;
  }

  goToPreLoginContactUs(lob: string) {
    this.router.navigate(['public/pre-login-contact-us', lob]);
    this.close(true);
  }

  goToAccessCodePage() {
    const trackCh = getAdobeSiteSection(this.router.url);
    this.analytics.trackEventOther({}, 'Contact Us', 'acCFBSU001', {
      eVar119: 'MTD-3316',
      eVar120: 'contact-cigna-modal-links',
      prop67: 'action',
      pageName: trackCh.pageName,
      channel: trackCh.channel,
      linkName: 'Find my access code',
      prop20: 'Contact Cigna modal',
    });

    this.router.navigate(['public/registration']);
    this.close(true);
  }

  goToServiceNow() {
    window.open(this._gw.getSnowUrl(), '_blank');
  }

  sendMail(recipientMail: string) {
    window.location.href = `mailto:${recipientMail}`;
  }

  toggleGetAppointed(): void {
    // if(!this.slideOpen )
    // {
    const trackCh = getAdobeSiteSection(this.router.url);
    this.analytics.trackEventOther({}, 'Contact Us', 'acCFBSU001', {
      eVar119: 'MTD-3316',
      eVar120: 'contact-cigna-modal-links',
      prop67: 'action',
      pageName: trackCh.pageName,
      channel: trackCh.channel,
      linkName: 'I need to get appointed',
      prop20: 'Contact Cigna modal',
    });
    // }

    this.showOnboardingDialog();
    this.close(false);

    // this.close(false, true);
    // this.slideOpen = !this.slideOpen;
  }

  toggleGetAppointedOld(): void {
    // if(!this.slideOpen )
    // {
    const trackCh = getAdobeSiteSection(this.router.url);
    this.analytics.trackEventOther({}, 'Contact Us', 'acCFBSU001', {
      eVar119: 'MTD-3316',
      eVar120: 'contact-cigna-modal-links',
      prop67: 'action',
      pageName: trackCh.pageName,
      channel: trackCh.channel,
      linkName: 'I need to get appointed',
      prop20: 'Contact Cigna modal',
    });
    // }
    this.slideOpen = !this.slideOpen;
  }

  redirectToForm(lob: string) {
    const adobeSection = getAdobeSiteSection(this.router.url);
    this.router.navigate(['secure/contact-us', lob]);
    this.close(true);
    this.analytics.trackEventOther({}, 'Submit Support Request', 'acCFBSU001', {
      eVar119: 'MTD-2340',
      eVar120: 'post-submit-support-link',
      prop67: 'action',
      channel: adobeSection.channel,
      prop20: 'Post Login Contact Cigna modal',
      pageName: adobeSection.pageName,
    });
  }
}
